module.exports = __webpack_public_path__ + "assets/img/first.a62cd133.png";